import React, { useEffect } from 'react';
import { ENV_GOOGLE_MAPS_API_KEY } from 'utils/secrets';

const GoogleMapsScriptLoader: React.FC = () => {
  useEffect(() => {
    // Check if script is already loaded
    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com/maps/api/js"]',
    );

    if (existingScript) {
      return undefined; // Script already loaded
    }

    // Check if API key is available
    if (!ENV_GOOGLE_MAPS_API_KEY) {
      console.warn('Google Maps API key is not configured');
      return undefined;
    }

    // Create and inject the script
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${ENV_GOOGLE_MAPS_API_KEY}&libraries=places&v=weekly`;
    script.async = true;
    script.defer = true;
    script.id = 'google-maps-script';

    document.head.appendChild(script);

    // No cleanup needed - we want to keep the script loaded for the app lifetime
    return undefined;
  }, []);

  return null; // This component doesn't render anything
};

export default React.memo(GoogleMapsScriptLoader);
